import React from 'react';
import { useI18n } from '../I18nContext';
import { Globe } from 'lucide-react';

function LanguageSwitcher() {
  const { locale, changeLocale } = useI18n();
  return (
    <div className="inline-flex items-center gap-1 text-xs">
      <Globe size={14} className="opacity-70" />
      <select
        value={locale}
        onChange={e => changeLocale(e.target.value)}
        aria-label="Language"
        className="bg-white/15 border-none text-white px-1.5 py-1 rounded-lg text-xs font-semibold cursor-pointer outline-none"
      >
        <option value="en" style={{ color: '#000' }}>EN</option>
        <option value="sw" style={{ color: '#000' }}>SW</option>
      </select>
    </div>
  );
}

export default LanguageSwitcher;
